import { accent, type AccentKey } from './theme';

interface FloatingConsultProps {
  label?: string;
  accentKey: AccentKey;
  href?: string;
}

export default function FloatingConsult({ label = '咨询方案', accentKey, href = '#consultation' }: FloatingConsultProps) {
  const a = accent(accentKey);

  return (
    <a
      href={href}
      className={`fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 px-5 py-3 rounded-full ${a.solid} text-foreground-950 text-sm font-medium shadow-[0_8px_24px_rgba(0,0,0,0.18)] whitespace-nowrap cursor-pointer transition-all ${a.solidHover} hover:-translate-y-0.5`}
    >
      <i className="ri-customer-service-2-line"></i>
      {label}
    </a>
  );
}